<template>
  <span v-if="operation.sessionHistory">
    <span @click="toggleTooltip(); mostrar=!mostrar"  >
      <span class="cursor-pointer ml-1">
        <EyeClosedIcon v-if="operation.tooltipVisible" />
        <EyeOpenIcon v-else />
      </span>
    </span>
    <span>
      <md-tooltip
        v-show="mostrar"
        class="tooltip-message"
        :md-active.sync="operation.tooltipVisible"
        md-direction="right"
      >
        <div>
          ID Sesión: {{ operation.sessionHistory.id }}
        </div>
        <div>
          IP: {{ operation.sessionHistory.ip }}
        </div>
        <div>
          Email Usuario: {{ operation.sessionHistory.userHistoryEmail }}
        </div>
        <div>
          Dispositivo: {{ operation.sessionHistory.device }}
        </div>
      </md-tooltip>
    </span>
  </span>
</template>
<script>
import EyeOpenIcon from '@/components/icons/EyeOpenIcon.vue';
import EyeClosedIcon from '@/components/icons/EyeClosedIcon.vue';

export default {
  name: 'operation-session-history-tooltip',
  components: {
    EyeOpenIcon,
    EyeClosedIcon,
    mostrar: false,
  },

  props: {
    operation: {
      type: Object,
      required: true,
    },
  },

  mounted() {
    window.addEventListener('wheel', this.handleScroll);
    window.addEventListener('touchmove', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('wheel', this.handleScroll);
    window.removeEventListener('touchmove', this.handleScroll);
  },

  methods: {
    toggleTooltip() {
      if (this.operation.tooltipVisible) {
        this.$set(this.operation, 'tooltipVisible', false);
        return;
      }
      this.$set(this.operation, 'tooltipVisible', true);
    },

    handleScroll() {
      if (this.operation.tooltipVisible) {
        this.$set(this.operation, 'tooltipVisible', false);
      }
    },
  },
};
</script>

<style scoped>
.tooltip-message {
  border: 1px solid var(--neutral-2);
  border-radius: 3px;
  margin: 0 15px 0 30px;
  z-index: 900;
  height: auto;
  overflow: auto;
  max-width: 250px;
  white-space: normal;
}
</style>
